export default __webpack_public_path__ + "static/team2-89f18788e06c36c16568295b3d495c11.jpg";